import { html } from 'lit';

export const iconMinus = html`
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5.7,5.8h3.4c.4,0,.8-.3.8-.8s-.4-.8-.8-.8H.8c-.4,0-.7.4-.7.8s.3.8.7.8h3.4"
    />
  </svg>
`;
